import {
  ReactElement, useEffect, useState, useMemo,
} from 'react';
import { HistoryGraphContainer, TitleGraph } from '../../../styles';
import { ComingSoonBadge } from '../../../BigNumbers/components/Card/styles';
import Skeleton from 'react-loading-skeleton';
import { useTranslation } from 'react-i18next';
import { useFilterContext } from '../../../contexts/FilterContext';
import {
  CardsContainerLoading, DetailsButton, CardsGraphContainer, ContentWrapper, ContentImage, BadgeContainer,
} from '../styles';
import contentEnergyEfficiency from './content-energy-efficiency.svg';
import { EnergyEfficiencyCardContainer } from './styles';

interface EnergyEfficiencyCardProps {
  expandedSplit: boolean;
  order: number;
  loading?: boolean,
  onClickDetails?: () => void;
}

export function EnergyEfficiencyCard({
  expandedSplit,
  order,
  loading = false,
  onClickDetails,
}: Readonly<EnergyEfficiencyCardProps>): ReactElement {
  const { t } = useTranslation();
  const { client, filtersDependencies } = useFilterContext();
  const [isFiltering, setIsFiltering] = useState(false);

  useEffect(() => {
    if (client) {
      setIsFiltering(true);
      const timer = setTimeout(() => {
        setIsFiltering(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [filtersDependencies, client]);

  const generalLoading = useMemo(() => loading || isFiltering, [loading, isFiltering]);

  if (generalLoading) {
    return (
      <CardsContainerLoading style={{ order }}>
        <Skeleton
          height="360px"
          borderRadius="8px"
          className="skeleton-span"
          containerClassName="skeleton-container-span"
        />
      </CardsContainerLoading>
    );
  }

  return (
    <EnergyEfficiencyCardContainer order={order} expandedSplit={expandedSplit}>
      <TitleGraph style={{ opacity: 0.6 }}>{t('eficienciaEnergetica')}</TitleGraph>
      <CardsGraphContainer style={{ opacity: 0.6 }}>
        <ContentWrapper>
          <ContentImage
            src={contentEnergyEfficiency}
            alt={t('eficienciaEnergetica')}
          />
        </ContentWrapper>
        <DetailsButton
          type="button"
          variant="primary-ghost"
          onClick={onClickDetails}
          style={{ filter: 'blur(2px)' }}
        >
          {t('verDetalhes')}
        </DetailsButton>
      </CardsGraphContainer>
      <BadgeContainer>
        <ComingSoonBadge>{t('emBreve')}</ComingSoonBadge>
      </BadgeContainer>
    </EnergyEfficiencyCardContainer>
  );
}
